import Alpine from "alpinejs";

document.addEventListener('alpine:init', () => {
    Alpine.store('ui', {
        showSearch: false,
        mobileMenuActive: false,
        glossaryReferenceActive: false,
        menuHeight: 0,
        headerHeight: 0,
        navHeight: 0,
        get headerNavHeight(){
            if(this.navHeight >= 0 && this.navHeight > this.headerHeight){
                return this.navHeight;
            } 

            return this.headerHeight;
        }
    })
})